import de from './de'
import fr from './fr'

const locales = {
  de,
  fr
}

export default locales
